export default __webpack_public_path__ + "static/media/line7.0578d6ed.svg";